import { Box, Fab, IconButton, Menu, MenuItem, TextField, Typography, useTheme } from "@mui/material";
import { useApplicationContext } from "../../../context/ApplicationContext";
import useErrorHandler from "../../../api/errorHandler/useErrorHandler";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { CHART_COLORS, Dashboard_Entity, Entity } from "../../../constant/ApplicationVariables";
import { LightTooltip } from "../../styled/CustomComponent";
import { Add, MoreHorizOutlined } from "@mui/icons-material";
import { font } from "../../../styles/font";
import CreateGraphComponent from "./CreateGraphComponent";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import GraphComponent from "./GraphComponent";
import GraphPreview from "./GraphPreview";
import DashboardCard from "../DashboardCard";


export default function RequirementToTestingDashboardContainer() {
    const { activeDashboard, setActiveDashboard, activeDashboardModule, setActiveDashboardModule } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const pathName = useLocation().pathname;

    const [openCreateGraphDialog, setOpenCreateGraphDialog] = useState(false);

    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);

    const [activeProperty, setActiveProperty] = useState({
        label: "All",
        value: ""
    });
    const [propertiesList, setPropertiesList] = useState([]);
    const [currentGraphData, setCurrentGraphData] = useState(null);
    const [searchText, setSearchText] = useState("");




    // card 
    // const [dataList, setOverviewList] = useState([
    //     {
    //         title: activeProperty,
    //         type: "doughnut",
    //         data: {
    //             labels: ['HIGH', 'MEDIUM', 'LOW'],
    //             datasets: [
    //                 {
    //                     // label: '# of Votes',
    //                     label: '',
    //                     data: [32, 40, 28],
    //                     backgroundColor: [
    //                         'rgba(255, 99, 132, 0.2)',
    //                         'rgba(54, 162, 235, 0.2)',
    //                         'rgba(255, 206, 86, 0.2)',
    //                         'rgba(75, 192, 192, 0.2)',
    //                         'rgba(153, 102, 255, 0.2)',
    //                         'rgba(255, 159, 64, 0.2)',
    //                     ],
    //                     borderColor: [
    //                         'rgba(255, 99, 132, 1)',
    //                         'rgba(54, 162, 235, 1)',
    //                         'rgba(255, 206, 86, 1)',
    //                         'rgba(75, 192, 192, 1)',
    //                         'rgba(153, 102, 255, 1)',
    //                         'rgba(255, 159, 64, 1)',
    //                     ],
    //                     borderWidth: 1,
    //                 },
    //             ],
    //         }
    //     }
    // ]);

    const [overviewList, setOverviewList] = useState([
        {
            title: "User Story",
            type: "counter",
            isSelectable: false,
            data: "2597"
        },
        {
            title: "Priority",
            type: "doughnut",
            isSelectable: true,
            data: {
                labels: ['HIGH', 'MEDIUM', 'LOW',],
                datasets: [
                    {
                        // label: '# of Votes',
                        label: '',
                        data: [32, 40, 28],
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                        ],
                        borderColor: [
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                        ],
                        borderWidth: 1,
                    },
                ],
            }
        }
    ]);


    // table, graph data - priority
    const list2 = [
        {
            name: "Folder1",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 40
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                },
            ]

        },
        {
            name: "Folder2",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 20
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                }
            ]
        },
        {
            name: "Folder3",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 20
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                }
            ]
        },
        {
            name: "Folder4",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 20
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                }
            ]
        },
        {
            name: "Folder5",
            value: 110,
            properties: [
                {
                    name: "HIGH",
                    value: 20
                },
                {
                    name: "MEDIUM",
                    value: 30
                },
                {
                    name: "LOW",
                    value: 60
                }
            ]
        }
    ]

    // table, graph data - state
    const list = [
        {
            name: "Folder1",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]

        },
        {
            name: "Folder2",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder3",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder4",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder5",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        }
    ];

    const graphList = [
        { title: "All Folder", list: list },
        { title: "5folders", list: list },
        { title: "3folders", list: list },
        { title: "2folders", list: list },
        { title: "7folders", list: list }
    ];




















    let priorityStateList = [
        {
            title: "Title of data",
            type: "doughnut",
            data: {
                labels: ["Folder1", "Folder2", "Folder3", "Folder4", "Folder5"],
                datasets: [
                    {
                        label: 'HIGH',
                        data: [12, 19, 45, 5, 89],
                    },
                    {
                        label: 'MEDIUM',
                        data: [56, 74, 54, 46, 6],
                    },
                    {
                        label: 'LOW',
                        data: [56, 45, 5, 66, 6],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            },
            tableList: [
                {
                    name: "Folder1",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]

                },
                {
                    name: "Folder2",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder3",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder4",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder5",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                }
            ]
        },
        {
            title: "Title of data2",
            type: "doughnut",
            data: {
                labels: ["Folder1", "Folder2", "Folder3", "Folder4", "Folder5"],
                datasets: [
                    {
                        label: 'HIGH',
                        data: [17, 20, 41, 7, 93],
                    },
                    {
                        label: 'MEDIUM',
                        data: [51, 64, 44, 36, 16],
                    },
                    {
                        label: 'LOW',
                        data: [51, 35, 7, 76, 16],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            },
            tableList: [
                {
                    name: "Folder1",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]

                },
                {
                    name: "Folder2",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder3",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder4",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                },
                {
                    name: "Folder5",
                    value: 110,
                    properties: [
                        {
                            name: "DRAFT",
                            value: 40
                        },
                        {
                            name: "APPROVED",
                            value: 30
                        },
                        {
                            name: "UNDER DEVELOPMENT",
                            value: 60
                        },
                        {
                            name: "COMPLETED",
                            value: 60
                        },
                        {
                            name: "CLOSED",
                            value: 50
                        },
                    ]
                }
            ]
        },


    ];



    let overviewlistDummy = [
        {
            title: "User Story",
            type: "counter",
            data: 7454,

        },
        {
            title: "Priority",
            type: "doughnut",
            data: {
                labels: ["HIGH", "MEDIUM", "LOW",],
                datasets: [
                    {
                        label: '',
                        data: [12, 19, 45,]
                    },

                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800",]
            },

        },
        {
            title: "State",
            type: "doughnut",
            data: {
                labels: ['DRAFT', 'INPROGRESS', 'APPROVED', "COMPLETED", "CLOSED"],
                datasets: [
                    {
                        label: '',
                        data: [32, 40, 28, 30, 50],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            },

        },
        {
            title: "Type",
            type: "doughnut",
            data: {
                labels: ['PROCESS', 'FUNCTIONAL', 'NON-FUNCTIONAL',],
                datasets: [
                    {
                        label: '',
                        data: [32, 40, 28],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800",]
            },

        },


    ];
















    const list5 = [
        {
            name: "Folder1",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]

        },
        {
            name: "Folder2",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder3",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder4",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        },
        {
            name: "Folder5",
            value: 110,
            properties: [
                {
                    name: "DRAFT",
                    value: 40
                },
                {
                    name: "APPROVED",
                    value: 30
                },
                {
                    name: "UNDER DEVELOPMENT",
                    value: 60
                },
                {
                    name: "COMPLETED",
                    value: 60
                },
                {
                    name: "CLOSED",
                    value: 50
                },
            ]
        }
    ];


    const handleOpenGraphPreview = (item) => {
        setCurrentGraphData(item);
    }

    const handleCloseGraphPreview = () => {
        setCurrentGraphData(null);
    }

    const handleOpenCreateGraph = () => {
        setOpenCreateGraphDialog(true)
    }

    const handleCloseCreateGraph = () => {
        setOpenCreateGraphDialog(false)
    }


    const handleToggleMoreMenu = (event) => {
        if (moreMenuAnchorEl) {
            setMoreMenuAnchorEl(null);
        } else {
            setMoreMenuAnchorEl(event.currentTarget);
        }
    }

    let DATASETS = {
        // label: '# of Votes',
        label: '',
        data: [],
        backgroundColor: CHART_COLORS?.map(color => color[400]),
        borderColor: CHART_COLORS?.map(color => color[700]),
        borderWidth: 1,
    }

    function transformData(labelList, datasetList, colorList) {
        const labels = labelList?.map(item => item);
        const datasets = datasetList?.map((dataSet, index) => ({
            label: dataSet?.label,
            data: dataSet?.data,
            backgroundColor: colorList ? colorList[index] : CHART_COLORS[index][400],
            borderColor: colorList ? colorList[index] : CHART_COLORS[index][700],
            borderWidth: 1,
        }));

        return { labels, datasets };
    }

    let overViewDummyDataList = [
        {
            title: "Title of data",
            type: "charttype",
            data: {
                labels: ["label1", "label1", "label2", "label3", "label4"],
                datasets: [
                    {
                        label: '# of Votes',
                        data: [12, 19, 3, 5, 6],
                    },
                    {
                        label: '$ of Votes',
                        data: [56, 74, 5, 5, 6],
                    },
                ],
                colorsList: ["#7d7d8d", "#3f5gd1", "#ff9800", "#4caf50", "#2196f3"]
            }
        }
    ];

    console.log(transformData(overViewDummyDataList[0]?.data.labels, overViewDummyDataList[0]?.data.datasets, overViewDummyDataList[0]?.data?.colorsList), "overViewDummyData");



    // set the data list
    useEffect(() => {
        setOverviewList([
            {
                title: "User Story",
                type: "counter",
                data: "2597"
            },
            {
                // title: "activeProperty",
                title: "Priority",
                type: "doughnut",
                data: {
                    labels: ['HIGH', 'MEDIUM', 'LOW',],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28],
                        },
                    ],
                }
            },
            {
                title: "State",
                type: "doughnut",
                data: {
                    labels: ['DRAFT', 'INPROGRESS', 'APPROVED', "COMPLETED", "CLOSED"],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28, 30, 50],
                        },
                    ],
                }
            },
            {
                title: "Type",
                type: "doughnut",
                data: {
                    labels: ['PROCESS', 'FUNCTIONAL', 'NON-FUNCTIONAL',],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28],
                        },
                    ],
                }
            },
            {
                title: "MOSCOW",
                type: "doughnut",
                data: {
                    labels: ["MUST HAVE", "SHOULD HAVE", "COULD HAVE", "WONT HAVE"],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28, 30],

                        },
                    ],
                }
            },
            {
                title: "Confidentiality",
                type: "doughnut",
                data: {
                    labels: ['CONFIDENTIAL', 'SENSITIVE', 'UNCLASSIFIED',],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32, 40, 28],
                        },
                    ],
                }
            },
            {
                title: "Business Value",
                type: "doughnut",
                data: {
                    labels: ['Business Value',],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [32,],
                        },
                    ],
                }
            },
            {
                title: "User Value",
                type: "doughnut",
                data: {
                    labels: ["User Value",],
                    datasets: [
                        {
                            ...DATASETS,
                            data: [46,],
                        },
                    ],
                }
            }
        ])
    }, [activeProperty]);



    // left sidebar list of dashboard module
    useEffect(() => {
        // left list of properties
        let userStoryList = [
            {
                label: "Overview",
                value: "overview"
            },
            {
                label: "Priority",
                value: "Priority"
            },
            {
                label: "State",
                value: "State"
            },
            {
                label: "Type",
                value: "Type"
            },
            {
                label: "MOSCOW",
                value: "MOSCOW"
            },
            {
                label: "Confidentiality",
                value: "Confidentiality"
            },
            {
                label: "Owner",
                value: "Owner"
            },
            {
                label: "Business Value",
                value: "Business Value"
            },
            {
                label: "User Value",
                value: "User Value"
            },
            {
                label: "Assigned To",
                value: "Assigned To"
            },
            {
                label: "Story Points",
                value: "Story Points"
            },

            {
                label: "Linked Usecase",
                value: "Linked Usecase"
            },
            {
                label: "Linked TestCase",
                value: "Linked TestCase"
            },
            {
                label: "Attachments",
                value: "Attachments"
            },
            {
                label: "Acceptance Criteria",
                value: "Acceptance Criteria"
            },
            {
                label: "Dependencies",
                value: "Dependencies"
            },
            {
                label: "Comments",
                value: "Comments"
            },
            {
                label: "Business Unit",
                value: "Business Unit"
            },
            {
                label: "Vendor",
                value: "Vendor"
            },
            {
                label: "External Party",
                value: "External Party"
            }
        ];

        let useCaseList = [
            {
                label: "Overview",
                value: "overview"
            },
            {
                label: "Priority",
                value: "Priority"
            },
            {
                label: "State",
                value: "State"
            },
            {
                label: "Type",
                value: "Type"
            },
            {
                label: "Status",
                value: "Status"
            },
            {
                label: "Owner",
                value: "Owner"
            },


            {
                label: "Assigned To",
                value: "Assigned To"
            },


            {
                label: "Linked UserStory",
                value: "Linked UserStory"
            },
            {
                label: "Linked TestCase",
                value: "Linked TestCase"
            },

            {
                label: "Attachments",
                value: "Attachments"
            },
            {
                label: "Steps",
                value: "Steps"
            },

            {
                label: "Comments",
                value: "Comments"
            },


        ];

        let testCaseList = [
            {
                label: "Overview",
                value: "overview"
            },
            {
                label: "Priority",
                value: "Priority"
            },
            {
                label: "Type",
                value: "Type"
            },
            {
                label: "Status",
                value: "Status"
            },
            {
                label: "Category",
                value: "Category"
            },
            {
                label: "Candidate For Regression",
                value: "Candidate For Regression"
            },
            {
                label: "Environment",
                value: "Environment"
            },
            {
                label: "Owner",
                value: "Owner"
            },


            {
                label: "Assigned To",
                value: "Assigned To"
            },

            {
                label: "Executed By",
                value: "Executed By"
            },

            {
                label: "Execution Date",
                value: "Execution Date"
            },

            {
                label: "Execution Mode",
                value: "Execution Mode"
            },
            {
                label: "Execution Environment",
                value: "Execution Environment"
            },
            {
                label: "Execution History",
                value: "Execution History"
            },


            {
                label: "Linked Usecase",
                value: "Linked Usecase"
            },
            {
                label: "Linked TestCase",
                value: "Linked TestCase"
            },
            {
                label: "Attachments",
                value: "Attachments"
            },
            {
                label: "Steps",
                value: "Steps"
            },
            {
                label: "Pre Condition",
                value: "Pre Condition"
            },
            {
                label: "Post Condition",
                value: "Post Condition"
            },
            {
                label: "Expected Result",
                value: "Expected Result"
            },

            {
                label: "Actual Result",
                value: "Actual Result"
            },

            {
                label: "Comments",
                value: "Comments"
            },



        ];


        if (activeDashboard?.value === Dashboard_Entity.userStory.value) {
            setActiveDashboardModule(userStoryList[0]?.value);
            setPropertiesList(userStoryList);
        } else if (activeDashboard?.value === Dashboard_Entity.useCase.value) {
            setActiveDashboardModule(useCaseList[0]?.value);
            setPropertiesList(useCaseList)
        } else if (activeDashboard?.value === Dashboard_Entity.testCase.value) {
            setActiveDashboardModule(testCaseList[0]?.value);
            setPropertiesList(testCaseList)
        }


    }, [activeDashboard]);

    console.log(overviewList, "overviewList", activeProperty);
    console.log(currentGraphData, "currentGraphData");

    console.log([...overviewList?.filter((item) => item?.type === "counter"), ...overviewList?.filter((item) => item?.type !== "counter")?.map((item) => ({ ...item, data: transformData(item?.data.labels, item?.data.datasets) }))], "overviewList2")

    return (
        <Box className="flex-1 flex gap-4 overflow-hidden box-border">



            {/* left list of properties */}
            {(activeDashboard?.value === Entity.userStory || activeDashboard?.value === Entity.useCase || activeDashboard?.value === Entity.testCase) && (
                <Box className="flex flex-col gap-4 px-0 py-0 w-[18%] h-full">
                    <TextField placeholder="Search" />

                    <Box className="flex-1 flex flex-col gap-2 overflow-y-auto">
                        {
                            propertiesList?.map((item, index) => {
                                return (
                                    <Box className="flex items-center gap-2 px-2 py-1" sx={{ cursor: "pointer", background: activeDashboardModule === item?.value ? theme.palette.background.paper : "none", "&:hover": { background: theme.palette.background.paper } }} borderRadius={theme.shape.borderRadius} onClick={() => setActiveDashboardModule(item?.value)}>
                                        <Typography fontSize={font.size.fs_5} color="textSecondary">{item?.label}</Typography>
                                    </Box>
                                )
                            })
                        }
                    </Box>
                </Box>
            )}



            {/* dashboard main container */}
            <Box className="flex-1 flex flex-col gap-4 relative overflow-hidden">



                {activeDashboardModule !== "overview" && (
                    <Box className="absolute bottom-2 right-2 z-10">
                        <LightTooltip title={`Create Graph`}>
                            <Fab
                                color="secondary"
                                // disabled={openEditStoryDialog}
                                onClick={handleOpenCreateGraph}
                                sx={{ boxShadow: "none" }}>
                                <Add />
                            </Fab>
                        </LightTooltip>
                    </Box>
                )}

                {activeDashboardModule === "overview" && (
                    <Box className="absolute bottom-2 right-2 z-10">
                        <LightTooltip title={`Add `}>
                            <Fab
                                color="secondary"
                                // disabled={openEditStoryDialog}
                                // onClick={handleOpenCreateGraph}
                                sx={{ boxShadow: "none" }}>
                                <Add />
                            </Fab>
                        </LightTooltip>
                    </Box>)}

                {openCreateGraphDialog && (
                    <Box className={`absolute top-0 right-0 bottom-0 left-0  w-full h-full backdrop-blur-md bg-white z-50 flex items-center justify-center overflow-hidden`} borderRadius={theme.shape.borderRadius} >
                        <CreateGraphComponent onClose={handleCloseCreateGraph} />
                    </Box>
                )}




                {/* header */}
                <Box className=" w-full h-fit flex items-center justify-between gap-4 ">

                    <Box className="flex items-center gap-2 w-72 ">

                        <DesktopDatePicker
                            // label="Start Date"
                            onChange={(newValue) => {
                                // handle start date change
                            }}
                            renderInput={(params) => <TextField placeholder="Date" variant="standard" {...params} />}
                        />
                    </Box>

                    <TextField placeholder="Search" type="search" value={searchText} onChange={(e) => setSearchText(e.target.value)} />

                </Box>


                {/* other properites container */}
                {activeDashboardModule !== "overview" && (
                    <Box className="flex-1 flex flex-col gap-0 relative overflow-y-auto ">


                        {/* card list container */}
                        {!currentGraphData ? (
                            <Box
                                className="grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 w-full h-fit  "
                            //  className="flex items-center flex-wrap gap-4 w-full h-fit  "

                            >
                                {
                                    priorityStateList
                                        ?.length === 0 ? (
                                        <Box className="flex items-center  ">
                                            <Typography>No data</Typography>
                                        </Box>

                                    ) :
                                        priorityStateList
                                            ?.filter((item => item?.title?.toLowerCase()?.includes(searchText?.toLowerCase())))
                                            ?.length === 0 ? (
                                            <Box className="flex items-center ">
                                                <Typography>No data</Typography>
                                            </Box>

                                        ) :
                                            priorityStateList
                                                ?.filter((item => item?.title?.toLowerCase()?.includes(searchText?.toLowerCase())))
                                                ?.map((item, index) => {
                                                    return (
                                                        <Box className=" flex flex-col gap-0 px-0 py-0 overflow-auto  w-full max-w-[440px] h-72  " bgcolor={theme.palette.background.paper} borderRadius={theme.shape.borderRadius} >
                                                            <Box className="flex items-center justify-between gap-4 px-4 py-2 border-b">
                                                                <Typography fontSize={font.size.fs_5} color="textSecondary">{item?.title}</Typography>

                                                                <IconButton onClick={handleToggleMoreMenu}>
                                                                    <MoreHorizOutlined />
                                                                </IconButton>
                                                            </Box>

                                                            <Box className="flex-1 flex items-center  gap-4 px-0 py-0 cursor-pointer select-none  relative overflow-auto" onClick={() => handleOpenGraphPreview(item)}>
                                                                <Box className="flex absolute left-0 top-0 w-full h-full"></Box>
                                                                <GraphComponent title={item?.title} data={item?.data} style={{ width: "100%", height: "100%" }} />
                                                            </Box>
                                                        </Box>
                                                    )
                                                })
                                }
                            </Box>) : (
                            <Box className={`absolute top-0 right-0 bottom-0 left-0  w-full h-full backdrop-blur-md bg-white z-50 flex items-center justify-center overflow-hidden`} borderRadius={theme.shape.borderRadius} >
                                <GraphPreview data={currentGraphData} onClose={handleCloseGraphPreview} />
                            </Box>
                        )}

                    </Box>
                )}

                {/* overview container  */}
                {activeDashboardModule === "overview" && (
                    <Box className="flex-1 flex flex-col gap-0 overflow-y-auto">
                        <Box className={`grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 pl-0 py-0`}>
                            {
                                overviewlistDummy?.map((item, index) => {
                                    return (
                                        <Box
                                            key={index}
                                            className={` overflow-hidden rounded-lg border hover:shadow-2xl  backdrop-blur-md transition-all ease-in-out duration-300 
                                            h-[320px]
                                     `}
                                            bgcolor={theme.palette.card.main}
                                        // onClick={() => handleOpenProject(project)}
                                        // sx={{ border: `1px solid transparent`, "&:hover": { border: `1px solid ${theme.palette.primary.main}` } }}
                                        >
                                            <DashboardCard
                                                item={item}
                                            // handleClick={() => handleOpenUserStory(item)}
                                            // handleChangeCheckbox={handleChangeCheckbox}
                                            // handleOpenLinkTag={handleOpenLinkTag}
                                            />

                                        </Box>
                                    )
                                })
                            }
                        </Box>
                    </Box>
                )}

            </Box>


            {/* more menu */}
            <Menu
                anchorEl={moreMenuAnchorEl}
                open={Boolean(moreMenuAnchorEl)}
                onClose={handleToggleMoreMenu}
            >
                <MenuItem> Add to Project Dashboard</MenuItem>
                <MenuItem> Duplicate</MenuItem>
                <MenuItem>Edit</MenuItem>
                <MenuItem> Delete</MenuItem>
            </Menu>
        </Box>
    )
}
